<template>
    <div class="border border-gray-400 px-3 sm:px-6 pb-8 mt-2 mt-8 sm:-mt-px mb-8">
        <survey-scheduled
            v-model="survey_is_scheduled"
            :read_only="read_only"
        />

        <div v-if="survey_is_scheduled">
            <survey-date
                :commercial="commercial"
                :read_only="read_only"
            />

            <survey-who-pays
                :commercial="commercial"
                :read_only="read_only"
            />
        </div>
    </div>
</template>

<script>
import SurveyScheduled from './survey-scheduled.vue';
import SurveyDate from './survey-date.vue';
import SurveyWhoPays from './survey-who-pays.vue';

export default {
    components: {
        SurveyScheduled,
        SurveyDate,
        SurveyWhoPays,
    },

    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            survey_is_scheduled: this.commercial.survey_is_scheduled,
        }
    },
}
</script>
